// extracted by mini-css-extract-plugin
export default {"container":"style_container__XHqpI","readOnly":"style_readOnly__Lvr+q","star":"style_star__YHcJc"};